// Function to Reinitialize carousels of all product cards.

function reinitializeCarousels() {
  const carousels = document.querySelectorAll(".splide-product-card-images");
  carousels.forEach((carousel) => {
    const splide = new Splide(carousel);
    const bar = carousel.querySelector(".product-card-carousel-progress-bar");
    splide.on("mounted move", () => {
      const end = splide.Components.Controller.getEnd() + 1;
      const rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = `${100 * rate}%`;
    });
    splide.mount();
  });
}

// Function to enable hover effect on add to cart  buttons

function reinitializeCardHoverAtcButton() {
  console.log("Data Updated Card!");
  document
    .querySelectorAll(".product-card-plp:not(.product-card-plp-add-ons)")
    .forEach((card) => {
      const featuresColors = card.querySelector(".product-card-feature-colors");
      const atcButtonCard = card.querySelector(".product-card-add-to-cart-btn");
      const soldOutButton = card.querySelector(".product-card-sold-out-btn");

      card.addEventListener("mouseenter", () => {
        if (soldOutButton) soldOutButton.style.opacity = 0.5;
        if (featuresColors) featuresColors.style.opacity = 0;
        if (atcButtonCard) atcButtonCard.style.opacity = 1;
      });

      card.addEventListener("mouseleave", () => {
        if (soldOutButton) soldOutButton.style.opacity = 0;
        if (featuresColors) featuresColors.style.opacity = 1;
        if (atcButtonCard) atcButtonCard.style.opacity = 0;
      });
    });
}

reinitializeCardHoverAtcButton();

// Function to perform add to cart actions, like adding to cart and changing background color on submit.
function performCustomAction(button) {
  console.log(button);
  button.style.background = "#50fea2";
  button.style.color = "#000";
  button.innerHTML = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.0003 5.83333L8.00033 15.8333L3.41699 11.25L4.59199 10.075L8.00033 13.475L16.8253 4.65833L18.0003 5.83333Z" fill="black"></path>
    </svg> Added to Cart`;
}

// Function to re-apply Buy Now button functionality
const reinitializeBuyNowButton = () => {
  document.body.addEventListener("click", (event) => {
    const button = event.target.closest(".buy-now-button button");
    if (button) {
      event.preventDefault();
      performCustomAction(button);
      const form = button.closest("form");
      if (form) form.submit();
    }
  });
};

reinitializeBuyNowButton();

class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          border-radius: 5px;
          overflow: hidden;
        }
        .header {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .icon {
          margin-right: 10px;
          order: 2;
          display: flex;
          align-items: center;
        }
        .content {
          height: 0;
          overflow: hidden;
          transition: height 0.3s ease-in-out;
          background: white;
          will-change: height;
        }
        .content.open {
          height: auto;
          margin-top: 8px;
        }
        .toggle-icon-open,
        .toggle-icon-closed {
          display: none;
        }
        .toggle-icon-open.active {
          display: inline;
        }
        .toggle-icon-closed.active {
          display: inline;
        }

        #track-order-info .icon{
        display:none;}
      </style>
      <div class="header">
        
        <slot name="title"></slot>
        <span class="toggle-icon-wrapper">
          <span class="toggle-icon-closed active"><slot name="toggle-icon"></slot></span>
          <span class="toggle-icon-open"><slot name="toggle-icon-open"></slot></span>
        </span>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    `;

    this.content = this.shadowRoot.querySelector(".content");
    this.iconClosed = this.shadowRoot.querySelector(".toggle-icon-closed");
    this.iconOpen = this.shadowRoot.querySelector(".toggle-icon-open");

    this.isOpen = false;

    this.shadowRoot
      .querySelector(".header")
      .addEventListener("click", () => this.toggleContent());

    requestAnimationFrame(() => this.updateOpenState());
  }

  static get observedAttributes() {
    return ["open"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open") {
      this.updateOpenState();
    }
  }

  updateOpenState() {
    const content = this.content;

    // Clear any previous transitionend listener to avoid stacking
    content.removeEventListener("transitionend", this._onTransitionEnd);

    if (this.hasAttribute("open")) {
      this.isOpen = true;

      // Measure full height
      const fullHeight = content.scrollHeight + "px";

      // Set to that height to trigger transition
      content.style.height = fullHeight;

      // After transition, remove inline height to allow auto layout
      this._onTransitionEnd = () => {
        content.style.height = "auto";
        content.removeEventListener("transitionend", this._onTransitionEnd);
      };
      content.addEventListener("transitionend", this._onTransitionEnd);

      // Toggle icons
      this.iconClosed.classList.remove("active");
      this.iconOpen.classList.add("active");
    } else {
      this.isOpen = false;

      // Set height to current before collapsing
      const currentHeight = content.scrollHeight + "px";
      content.style.height = currentHeight;

      // Force reflow
      void content.offsetHeight;

      // Set height to 0 to start collapse animation
      content.style.height = "0px";

      this.iconClosed.classList.add("active");
      this.iconOpen.classList.remove("active");
    }
  }

  toggleContent() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.setAttribute("open", "");
    } else {
      this.removeAttribute("open");
    }
  }
}

customElements.define("collapsible-content", CollapsibleContent);

class PopUp extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: none; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 20px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); border-radius: 5px; }
        :host([open]) { display: block; }
        
        .content { position: relative; z-index: 10; overflow: scroll; position: fixed; top: 0; height: 100%; }
      </style>
      
      <div class="backdrop"></div>
      <div class="content">
        <slot></slot>
      </div>
    `;
  }

  connectedCallback() {
    this.shadowRoot
      .querySelector(".backdrop")
      .addEventListener("click", () => this.close());
  }

  open() {
    console.log("Open method called");
    this.setAttribute("open", "");
    this.dispatchEvent(new CustomEvent("popup-opened"));
  }

  close() {
    this.removeAttribute("open");
    this.dispatchEvent(new CustomEvent("popup-closed"));
  }

  toggle() {
    if (this.hasAttribute("open")) {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define("pop-up", PopUp);

let openPopupElem = document.querySelectorAll(".open-popup");
let closePopupElem = document.querySelectorAll("#close-popup");

if (openPopupElem) {
  openPopupElem.forEach((button) => {
    button.addEventListener("click", () => {
      document.getElementById("popup").setAttribute("open", "");
    });
  });
}

if (closePopupElem) {
  closePopupElem.forEach((button) => {
    button.addEventListener("click", () => {
      document.getElementById("popup").removeAttribute("open");
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  let requestAQuoteContainer = document.querySelector(".request-a-quote");
  // Open popup
  document.querySelectorAll(".product-popup-trigger").forEach((button) => {
    button.addEventListener("click", function () {
      const target = button.getAttribute("data-target");
      const popup = document.getElementById(target);

      popup.style.display = "flex";
      void popup.offsetHeight; // Force reflow to trigger CSS transition
      popup.classList.add("active");
      document.body.classList.add(
        "overflow-hidden",
        "on-popup-clicked-content"
      );

      if (requestAQuoteContainer) {
        requestAQuoteContainer.classList.add("popup-shown");
      }
    });
  });

  // Close popup via close button
  document.querySelectorAll(".popup-close").forEach((close) => {
    close.addEventListener("click", function () {
      const popup = close.closest(".product-popup-overlay");
      popup.classList.remove("active");
      document.body.classList.remove("overflow-hidden");

      setTimeout(() => {
        popup.style.display = "none";
      }, 300); // Match transition duration

      if (requestAQuoteContainer) {
        requestAQuoteContainer.classList.remove("popup-shown");
      }
    });
  });

  // Close popup by clicking outside the content
  document.querySelectorAll(".product-popup-overlay").forEach((overlay) => {
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        overlay.classList.remove("active");
        document.body.classList.remove("overflow-hidden");

        setTimeout(() => {
          overlay.style.display = "none";
        }, 300);
      }
    });
  });
});

// let productPageAddToCartButtons = document.querySelectorAll(
//   ".product .product-form__submit"
// );

// // Loop through each button and attach event listener
// productPageAddToCartButtons.forEach((button) => {
//   button.addEventListener("click", function (e) {
//     performCustomAction(button);
//     const form = button.closest("form");
//     if (form) form.submit();
//   });
// });

class CartAddRedirectButton extends HTMLElement {
  constructor() {
    super();

    const inventoryAvailable = parseInt(
      this.getAttribute("data-inventory-available"),
      10
    );
    const continueSelling =
      this.getAttribute("data-continue-selling") === "continue";

    const spinner = this.querySelector(".cart-loading-spinner");
    const content = this.querySelector(".cart-button-content");

    // Disable button only if inventory is 0 and continue selling is false
    if (inventoryAvailable === 0 && !continueSelling) {
      this.classList.add("disabled");
      this.style.pointerEvents = "none"; // Prevent clicks
      this.style.opacity = "0.5"; // Visual cue (optional)
      if (content) content.textContent = "SOLD OUT";
      return;
    }

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const variantId = this.getAttribute("data-variant-id");
      if (!variantId) {
        console.error("Variant ID is missing");
        return;
      }

      if (spinner && content) {
        spinner.classList.remove("hidden");
        content.classList.add("hidden");
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) {
            return response.text().then((text) => {
              throw new Error(text);
            });
          }
          return response.json();
        })
        .then(() => {
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("Cart add error:", error);

          if (spinner && content) {
            spinner.classList.add("hidden");
            content.classList.remove("hidden");
          }
        });
    });
  }
}

customElements.define("cart-add-redirect-button", CartAddRedirectButton);
